import { actionsTypes, addUIFields } from "@/util/action-types";
import { cloneDeep } from "lodash";

const getters = {
  WORKSPACES_LIST: ({ workspacesList }) => workspacesList,
  WORKSPACE: ({ workspace }) => {
    const workspaceData = cloneDeep(workspace);

    if (!workspaceData.knowledgeBaseChunkSize) {
      workspaceData.knowledgeBaseChunkSize = 1024;
    }
    if (!workspaceData.knowledgeBaseChunkOverlap) {
      workspaceData.knowledgeBaseChunkOverlap = 100;
    }
    if (!workspaceData.knowledgeBaseSimilarityTopK) {
      workspaceData.knowledgeBaseSimilarityTopK = 5;
    }
    return workspaceData;
  },
  WORKSPACE_SESSIONS: ({ workspaceSessions }) => workspaceSessions,

  WORKSPACE_LIST_LOADING: ({ isWorkspacesListLoading }) =>
    isWorkspacesListLoading,
  WORKSPACE_LOADING: ({ isWorkspaceLoading }) => isWorkspaceLoading,
  WORKSPACE_SESSIONS_LOADING: ({ isWorkspaceSessionsLoading }) =>
    isWorkspaceSessionsLoading,
  SEND_MESSAGE_LOADING: ({ isSendMessageLoading }) => isSendMessageLoading,
  WORKSPACE_UPDATE_LOADING: ({ isWorkspaceUpdateLoading }) =>
    isWorkspaceUpdateLoading,
  UPDATE_PARTICIPANTS_LOADING: ({ isUpdateParticipantsLoading }) =>
    isUpdateParticipantsLoading,
  IS_DELETE_WORKSPACE_LOADING: ({ isDeleteWorkspaceLoading }) =>
    isDeleteWorkspaceLoading,

  WORKSPACE_PROMPTS: ({ workspacePrompts }) => workspacePrompts || [],
  IS_WORKSPACE_PROMPTS_LOADING: ({ isWorkspacePromptsLoading }) =>
    isWorkspacePromptsLoading,
  IS_WORKSPACE_PROMPTS_ACTION_LOADING: ({ isWorkspaceActionLoading }) =>
    isWorkspaceActionLoading,
  SELECTED_WORKSPACE_PROMPT: ({ selectedPrompt }) => selectedPrompt || {},

  WORKSPACE_KNOWLEDGE_FILES: ({ workspaceKnowledgeFiles }) =>
    workspaceKnowledgeFiles || [],
  WORKSPACE_KNOWLEDGE_FILES_LOADING: ({ isWorkspaceKnowledgeFileLoading }) =>
    isWorkspaceKnowledgeFileLoading,

  WORKSPACE_GENERAL_ACTIONS: ({ generalActions, workspace }) =>
    generalActions ||
    addUIFields(workspace.general_actions, actionsTypes()) ||
    [],
  SELECTED_ACTION: ({ selectedAction }) => selectedAction,
  GET_ARTIFACT_LIST: ({ artifactList }) => artifactList,
  GET_IS_ARTIFACT_LIST_LOADING: ({ isArtifactListLoading }) => isArtifactListLoading,
};

export default getters;
